import { render, staticRenderFns } from "./widget-attachment.vue?vue&type=template&id=e0473628&"
import script from "./widget-attachment.vue?vue&type=script&lang=js&"
export * from "./widget-attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports